const InteractionEventName = {};
export default InteractionEventName;

InteractionEventName.DIALOG_SINGLE_OPTION_CHOSEN = "dialog_single_option_chosen";
InteractionEventName.DIALOG_MULTIPLE_OPTIONS_CHOSEN = "dialog_multiple_option_chosen";
InteractionEventName.DIALOG_STARTED = "dialog_started";
InteractionEventName.DIALOG_ENDED = "dialog_ended";